<template>
    <div class="body">
        <div class="top-box-top">
            <top />
        </div>
        <div class="bottom-box">
            <basecom />
            <div class="list">
                <Delete></Delete>
            </div>
        </div>
    </div>
</template>
<script>
import basecom from "@/components/base";
import top from "@/components/top";
import Delete from "@/components/categoryComponents/delete";
export default { 
    components: {
        basecom,
        Delete,
        top
    },
};
</script>
  
  
  
  
  